import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useLogoutMutation } from '../../api/auth/authApi';
import { useDispatch } from 'react-redux';
import { logOut } from '../../api/auth/authSlice';
import { useNavigate } from 'react-router';
import { CircularProgress } from '@mui/joy';

export function LogoutButton() {

    const [logout, { isLoading }] = useLogoutMutation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const submitLogout = async () => {
        try {
            await logout(undefined);

            dispatch(logOut());

            navigate("/login");
            
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div 
            className="flex gap-x-1 cursor-pointer hover:bg-gray-200 w-full rounded-[3px] px-[6px] py-[5px]"
            onClick={submitLogout}>
            {isLoading
            ?
            <div className="flex justify-center h-[20px] w-full">
                <CircularProgress sx={{
                    "--CircularProgress-progressThickness": "3px",
                    "--CircularProgress-trackThickness": "3px",
                    "--CircularProgress-size": "17px"
                }}/>
            </div>
            :
            <>
            <LogoutRoundedIcon sx={{ height: 20, width: 20 }}/>
            <p className="text-sm">Cerrar sesión</p>
            </>
            }
        </div>
    );
}